export const bus = new Vue()